import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getApartments } from "../services/apartment";

export function useGetApartments() {
  return useQuery({
    queryKey: ["apartments"],
    queryFn: () => getApartments(),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
